import { render, staticRenderFns } from "./AllOpenOrders.vue?vue&type=template&id=1c45593b&scoped=true"
import script from "./AllOpenOrders.vue?vue&type=script&lang=js"
export * from "./AllOpenOrders.vue?vue&type=script&lang=js"
import style0 from "./AllOpenOrders.vue?vue&type=style&index=0&id=1c45593b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c45593b",
  null
  
)

export default component.exports